import { gql } from "@apollo/client";

export const generateOneCompanyPolicyNudge = gql`
  mutation generateCompanyPolicyNudge($nudgeId: MongoID!) {
    CompanyPolicyNudge_GenerateOne(nudgeId: $nudgeId) {
      _id
      title
      description
      status
      ai_generated
      created_by_user {
        _id
        name
      }
      created_at
      updated_by_user {
        _id
        name
      }
      updated_at
    }
  }
`;
